export default __webpack_public_path__ + "static/media/flixr.047d7196.png";